/**
 * Formats a person's name by converting it to Title Case, while preserving
 * standard lowercase Portuguese particles (de, da, do, dos, das, e).
 */
export const formatPersonName = (name: string | undefined | null): string => {
  if (!name) {
    return "";
  }

  const lowercaseParticles = ["de", "da", "do", "dos", "das", "e"];

  return name
    .toLowerCase()
    .split(/\s+/)
    .map((word, index, words) => {
      if (lowercaseParticles.includes(word) && index > 0 && index < words.length - 1) {
        return word;
      }

      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join(" ");
};
